// React
import { ReactElement, useState } from 'react';
// Utils
import { LightenDarkenColor } from '@utmb/utils/colors';
import { v4 as uuidv4 } from 'uuid';
import { InView } from 'react-intersection-observer';
// Design System
import { PlaygroundsModal } from '@utmb/design-system/playgrounds/modal/PlaygroundsModal';
// Features
import { RaceItemView } from '@utmb/types/index';
import ContentCard from '@utmb/features/races/races-list/ContentCard';
import ImageCard from '@utmb/features/races/races-list/ImageCard';
// Interfaces
import { Slice } from '@utmb/types/slice-handler';
import { SliceRaceListView } from '@utmb/types/index';
// Styles
import '@reach/dialog/styles.css';
import styles from './races-list.module.scss';

export const RacesList = (props: Slice<SliceRaceListView>): ReactElement => {
    const { id, races } = props;

    function handleIsInView(isIntersecting: boolean, element: IntersectionObserverEntry): void {
        if (isIntersecting) {
            element.target.children[0].classList.remove(styles.race_animation_disappear);
        }
    }

    return (
        <div id={id} className={`container px-0 ${styles.root}`}>
            {races?.map((race: RaceItemView, idx: number) => (
                <InView key={uuidv4()} onChange={handleIsInView} rootMargin="-200px 0px" triggerOnce={true}>
                    <RaceCard {...race} id={race.id} className={`row ${styles.race_animation_disappear} ${styles.race_container}`} idx={idx} />
                </InView>
            ))}
        </div>
    );
};

interface RaceCard extends RaceItemView {
    idx: number;
    className?: string;
}

export const RaceCard = (props: RaceCard): ReactElement => {
    const { className, raceTheme, raceThemeIsDark, playgrounds } = props;

    const colorToUse = raceThemeIsDark ? raceTheme : LightenDarkenColor(raceTheme, -20);

    const [showDialog, setShowDialog] = useState(false);
    const [raceCardIsOpen, setRaceCardIsOpen] = useState(false);

    return (
        <div className={className}>
            <PlaygroundsModal playgrounds={playgrounds} isOpen={showDialog} onDismiss={setShowDialog} />
            <div className="col-12 col-md-12 col-xl-3 px-0 px-md-2 px-xl-0">
                <ImageCard isOpen={raceCardIsOpen} raceItem={props} />
            </div>

            <div className="col-12 col-md-12 col-xl-9 px-0 px-md-2 px-xl-0">
                <ContentCard
                    {...props}
                    colorToUse={colorToUse}
                    raceCardIsOpen={raceCardIsOpen}
                    setRaceCardIsOpen={setRaceCardIsOpen}
                    setShowDialog={setShowDialog}
                />
            </div>
        </div>
    );
};
